import '@googlemaps/extended-component-library/api_loader.js';
import '@googlemaps/extended-component-library/store_locator.js';
import {setStringLiterals} from '@googlemaps/extended-component-library/utils/localize.js';

setStringLiterals({
    LOCATOR_LIST_HEADER: 'Намерете локация близо до вас',
    LOCATOR_LIST_SUBHEADING: 'Всички адреси',
    LOCATOR_SEARCH_PROMPT: 'Въведете адреса или пощенския си код',
});

const CONFIGURATION = {
    mapOptions: {
        fullscreenControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        zoom: 14,
        zoomControl: true,
        maxZoom: 17,
        mapId: 'LOCATOR_MAP_ID'
    },
    capabilities: {
        input: true,
        autocomplete: true,
        directions: false,
        distanceMatrix: true,
        details: false,
        actions: false
    },
};

document.addEventListener('DOMContentLoaded', () => {
    const locator = document.querySelector('gmpx-store-locator');
    if (!locator) {
        console.error('Не намирам <gmpx-store-locator> елемента в DOM-а.');
        return;
    }

    locator.configureFromQuickBuilder(CONFIGURATION);
    locator.listings = [
        {
            title: 'Остромила',
            addressLines: [
                'ул. „Остромила" №54, 4004 Пловдив',
                'Пон–Пет: 08:00–20:00',
                'Съб-Нед: 09:00–19:00'
            ],
            position: {lat: 42.1151834314662, lng: 24.72668182446748},
        },
        {
            title: 'ж.к. „Младежки хълм" - Office Park Plovdiv',
            addressLines: [
                'бул. „Свобода" №65А, 4002 Пловдив',
                '24/7 (денонощно)'
            ],
            position: {lat: 42.14282680713838, lng: 24.720584749073797},
        },
        {
            title: 'Ритейл Парк Парк Макс',
            addressLines: [
                'бул. „Кукленско шосе" №8Б, 4002 Пловдив',
                'Пон–Пет: 08:00–20:00',
                'Съб-Нед: 09:00–19:00'
            ],
            position: {lat: 42.122315, lng: 24.757597},
        }
    ];

    console.log(locator.listings);
});
